import {Component, Renderer2} from '@angular/core';
import {SlimLoadingBarService} from 'ng2-slim-loading-bar';
import {Router, NavigationCancel, NavigationEnd} from '@angular/router';
import {LocalStorageService} from 'ngx-webstorage';
import {AuthenticationService} from './services/authentification.service';
import {RepositoryService} from './services/repository.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'selfcare-front';
  constructor(
              public router: Router,
              private localSt: LocalStorageService,
              private authenticationService: AuthenticationService) {
    router.events.subscribe(
      data => {
        if (data instanceof NavigationEnd && router.url.startsWith('/app')) {
          this.authenticationService.getSession().subscribe(() => {});
        }
      }
    );
  }
}
